import { render, staticRenderFns } from "./AddComplaint.vue?vue&type=template&id=5e181dc8&"
import script from "./AddComplaint.vue?vue&type=script&lang=js&"
export * from "./AddComplaint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports